import React from 'react';

export const MonsteraSpinner = ({ className = 'w-8 h-8', style = {} }) => (
  <img
    src="/monstera-spinner.png"
    alt=""
    className={`animate-spin ${className}`}
    style={{ objectFit: 'contain', ...style }}
    data-testid="monstera-spinner"
  />
);
